import React from 'react';
import { Section, FadeIn } from './ui/Section';
import { Shield, Search, Gift } from 'lucide-react';
export function Mechanism() {
  return <Section background="warm" className="relative overflow-hidden" data-id="element-117">
      <FadeIn data-id="element-118">
        <div className="text-center mb-16" data-id="element-119">
          <h2 className="text-3xl md:text-4xl font-serif text-[#3D1F2E] mb-4" data-id="element-120">
            El mecanismo: 4 piezas que cambian el juego
          </h2>
          <div className="w-24 h-1 bg-[#C4467E] mx-auto rounded-full" data-id="element-121" />
        </div>
      </FadeIn>

      <div className="space-y-16" data-id="element-122">
        {/* 1. Semáforo */}
        <FadeIn delay={0.2} data-id="element-123">
          <div className="bg-white/80 backdrop-blur-sm rounded-2xl p-8 shadow-lg border border-[#E8D5DC]" data-id="element-124">
            <div className="flex flex-col md:flex-row items-center gap-8" data-id="element-125">
              <div className="flex-shrink-0 bg-[#3D1F2E] p-6 rounded-full flex flex-col gap-4 shadow-inner" data-id="element-126">
                <div className="w-12 h-12 rounded-full bg-[#DC3545] shadow-[0_0_15px_rgba(220,53,69,0.6)] animate-pulse" data-id="element-127" />
                <div className="w-12 h-12 rounded-full bg-[#F0AD4E] opacity-30" data-id="element-128" />
                <div className="w-12 h-12 rounded-full bg-[#28A745] opacity-30" data-id="element-129" />
              </div>
              <div className="flex-1 text-center md:text-left" data-id="element-130">
                <h3 className="text-2xl font-bold font-serif text-[#3D1F2E] mb-2" data-id="element-131">
                  1) El Semáforo Anti‑Impulso
                </h3>
                <p className="text-[#7A5C6B] mb-6" data-id="element-132">
                  Una regla simple para decidir en 30 segundos:
                </p>
                <ul className="space-y-3 text-left inline-block" data-id="element-133">
                  <li className="flex items-center gap-3" data-id="element-134">
                    <span className="w-3 h-3 rounded-full bg-[#DC3545]" data-id="element-135" />
                    <span className="text-[#3D1F2E] font-medium" data-id="element-136">ROJO:</span>
                    <span className="text-[#7A5C6B]" data-id="element-137">
                      no se compra (se registra)
                    </span>
                  </li>
                  <li className="flex items-center gap-3" data-id="element-138">
                    <span className="w-3 h-3 rounded-full bg-[#F0AD4E]" data-id="element-139" />
                    <span className="text-[#3D1F2E] font-medium" data-id="element-140">
                      AMARILLO:
                    </span>
                    <span className="text-[#7A5C6B]" data-id="element-141">se espera 48h</span>
                  </li>
                  <li className="flex items-center gap-3" data-id="element-142">
                    <span className="w-3 h-3 rounded-full bg-[#28A745]" data-id="element-143" />
                    <span className="text-[#3D1F2E] font-medium" data-id="element-144">VERDE:</span>
                    <span className="text-[#7A5C6B]" data-id="element-145">se compra con ritual</span>
                  </li>
                </ul>
              </div>
            </div>
          </div>
        </FadeIn>

        {/* 2. Fricción */}
        <FadeIn delay={0.3} data-id="element-146">
          <div className="flex flex-col md:flex-row gap-6 items-start" data-id="element-147">
            <div className="flex-shrink-0 p-4 bg-[#FDE8F0]/80 rounded-full text-[#C4467E]" data-id="element-148">
              <Shield className="w-8 h-8" data-id="element-149" />
            </div>
            <div data-id="element-150">
              <h3 className="text-xl font-bold font-serif text-[#3D1F2E] mb-2" data-id="element-151">
                2) Fricción Inteligente
              </h3>
              <p className="text-[#7A5C6B] mb-4" data-id="element-152">
                Bloqueos prácticos que te cuidan cuando tú estás cansada:
              </p>
              <ul className="grid grid-cols-1 sm:grid-cols-2 gap-2 text-sm text-[#7A5C6B]" data-id="element-153">
                <li data-id="element-154">• Quitar tarjetas guardadas</li>
                <li data-id="element-155">• Apagar notificaciones</li>
                <li data-id="element-156">• Bloquear apps en horarios peligrosos</li>
                <li data-id="element-157">• Congelar tarjetas por la noche</li>
              </ul>
              <p className="mt-4 text-[#C4467E] font-medium italic" data-id="element-158">
                No es castigo. Es diseño.
              </p>
            </div>
          </div>
        </FadeIn>

        {/* 3. Auditoría */}
        <FadeIn delay={0.4} data-id="element-159">
          <div className="flex flex-col md:flex-row gap-6 items-start" data-id="element-160">
            <div className="flex-shrink-0 p-4 bg-[#FDE8F0]/80 rounded-full text-[#C4467E]" data-id="element-161">
              <Search className="w-8 h-8" data-id="element-162" />
            </div>
            <div data-id="element-163">
              <h3 className="text-xl font-bold font-serif text-[#3D1F2E] mb-2" data-id="element-164">
                3) Auditoría de Fugas
              </h3>
              <p className="text-[#7A5C6B] mb-4" data-id="element-165">
                Porque el control no solo es "no comprar". También es recuperar
                dinero que se va en:
              </p>
              <ul className="grid grid-cols-1 sm:grid-cols-2 gap-2 text-sm text-[#7A5C6B]" data-id="element-166">
                <li data-id="element-167">• Suscripciones</li>
                <li data-id="element-168">• Delivery por cansancio</li>
                <li data-id="element-169">• Gastos pequeños repetidos</li>
                <li data-id="element-170">• MSI que te aprietan sin que lo notes</li>
              </ul>
            </div>
          </div>
        </FadeIn>

        {/* 4. Ritual */}
        <FadeIn delay={0.5} data-id="element-171">
          <div className="flex flex-col md:flex-row gap-6 items-start" data-id="element-172">
            <div className="flex-shrink-0 p-4 bg-[#FDE8F0]/80 rounded-full text-[#C4467E]" data-id="element-173">
              <Gift className="w-8 h-8" data-id="element-174" />
            </div>
            <div data-id="element-175">
              <h3 className="text-xl font-bold font-serif text-[#3D1F2E] mb-2" data-id="element-176">
                4) Ritual de Recompensa sin Compra
              </h3>
              <p className="text-[#7A5C6B] mb-2" data-id="element-177">
                El punto más ignorado: si no tienes recompensa, vas a buscarla…
                en una tienda.
              </p>
              <p className="text-[#3D1F2E] italic" data-id="element-178">
                Aquí instalas un menú de gratificación "limpia" que se siente
                bien sin cobrarte ansiedad después.
              </p>
            </div>
          </div>
        </FadeIn>
      </div>
    </Section>;
}